import { createAccessControl } from 'better-auth/plugins/access';
import { defaultStatements, adminAc, userAc } from 'better-auth/plugins/admin/access';

// src/admin-acl.ts
var adminPermissions = {
  ...defaultStatements,
  records: ["sample", "list", "export"]
};

// src/admin-acl.ts
var ac = createAccessControl(adminPermissions);
var rootRole = ac.newRole({
  records: ["sample", "list", "export"],
  ...adminAc.statements
});
var userRole = ac.newRole({
  records: ["sample", "list", "export"],
  ...userAc.statements
});
var guestRole = ac.newRole({
  records: ["sample"],
  ...userAc.statements
});
var adminRoles = {
  root: rootRole,
  user: userRole,
  guest: guestRole
};

// src/types.ts
var GlobalAccessRole = /* @__PURE__ */ ((GlobalAccessRole2) => {
  GlobalAccessRole2["ROOT"] = "root";
  GlobalAccessRole2["USER"] = "user";
  GlobalAccessRole2["GUEST"] = "guest";
  return GlobalAccessRole2;
})(GlobalAccessRole || {});

// src/guards.ts
function isRoot(role) {
  return role === "root" /* ROOT */;
}
function isGuest(role) {
  return role === "guest" /* GUEST */;
}

export { GlobalAccessRole, ac, ac as adminAc, adminRoles, isGuest, isRoot, adminRoles as roles };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map